import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import useQueryApplicationCount from "./useQueryApplicationCount";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./ApplicationCountItem.scss";

export default function ApplicationApprovalStatusCountItem(props) {
  const { approvalStatus, statusLabel } = props;

  const {
    data: count,
    loading,
    errors,
  } = useQueryApplicationCount({ candidateApprovalStatus: approvalStatus });

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <div className="ApplicationApprovalStatusCountItem">
            <Row>
              <Col>
                <span>{statusLabel}</span>
              </Col>
              <Col>
                <span>{count}</span>
              </Col>
            </Row>
          </div>
        )}
      />
    </HorizontalLoader>
  );
}
